import Layout from "../../components/Layout";
import TopNav from "../../components/TopNav";
import UserTable from "../../components/Users/Tables/UserTable";
import TableTop from "../../components/TableTop";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "../../utils/axios";
import { userController } from "../../controllers/UserController";
import TopCard from "../../components/TopCard";
import React from "react";
import { FaUsers } from "react-icons/fa";
/** AntD Table */
import AntDTable from "../../components/Table/AntdTable";
import { CamelCaseToTitleCase } from "../../../src/utils/helpers";
import { themeColor as color } from "../../constant/color";
import TableSkimmer from "../../components/TableSkimmer";
import { getToken } from "../../utils/token";
import { Input, Select, Button, Card, Statistic } from "antd";
import { useSelector } from "react-redux";
import AddAppUser from "../../components/Modals/AddAppUser";
import AddUser from "../../components/Modals/AddUser";
import { BiUserCheck } from "react-icons/bi";
import {
  UserOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
import ExcelExport from "../../components/ExportExcel";
const Users = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { siteid, sitename } = useSelector((state) => state.projectSite);
  const [count, setCount] = useState({
    total: 0,
    active: 0,
    inactive: 0,
  });
  const [refresh, setRefresh] = useState(false);
  const [columns, setColumns] = useState([]);
  const [inputname, setinputname] = useState("");
  const [filter, setfilter] = useState("all");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        let res = await axios.post(
          "/auth/customeraccount/getallregisteredusers",
          {
            limit: 100,
            offset: 0,
          }
        );
        let result = userController(res);
        if (result.type !== "success") {
          toast[result.type](result.message);
          setLoading(false);
          return;
        }
        setLoading(false);
        setData(() => {
          if (filter == "all") {
            return result.message.body;
          } else if (filter == "active") {
            return result.message.body.filter(
              (i) => i.activestatus == "active"
            );
          } else if (filter == "inactive") {
            return result.message.body.filter(
              (i) => i.activestatus == "inactive"
            );
          }
        });

        setCount({
          total: result.message.meta.count,
          active:
            result.message.body.filter((i) => i.activestatus == "active")
              .length ?? 0,
          inactive:
            result.message.body.filter((i) => i.activestatus == "inactive")
              .length ?? 0,
        });
        return () => {};
      } catch (err) {
        toast.error(err.message);
        setLoading(false);
      }
    })();
  }, [refresh, filter]);

  const filteredData = data.filter(
    (i) =>
      i?.activestatus?.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i?.email?.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i?.firstname?.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i?.lastname?.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i?.username?.toLowerCase().trim().includes(inputname.toLowerCase()) ||
      i?.phone?.toLowerCase().trim().includes(inputname.toLowerCase())
  );
  const [usermodal, setusermodal] = useState(false);

  const { companyname } = useSelector((state) => state.domain);
  return (
    <Layout>
      {usermodal && (
        <AddUser
          refreshBtn={setRefresh}
          open={usermodal}
          setopen={setusermodal}
        />
      )}

      <div
        style={{
          marginBottom: 200,
        }}
        className=" bg-white rounded-md p-2 shadow-md"
      >
        <div className=" ">
          <div className="mt-2">
            <div className=" ">
              <div className="h-[50px] flex items-center justify-between">
                <div className="flex items-center">
                  <div className=" w-[15px] h-[25px] bg-[#e0c5ff] rounded-sm"></div>
                  <div className="font-semibold ml-2">
                    Total registered staff in your company
                  </div>
                </div>
                <Button
                  // icon={<BiUserCheck />}
                  className="!border-secondary flex items-center  !text-secondary"
                  onClick={() => setusermodal(true)}
                  type
                >
                  Add Staff
                </Button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-3 my-1 gap-4">
                <Card
                  className=" transition-all duration-300"
                  bodyStyle={{ padding: "20px" }}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-gray-600 text-sm font-medium mb-2">
                        Total Registered Staff
                      </div>
                      <Statistic
                        value={count.total}
                        valueStyle={{
                          fontSize: "28px",
                          fontWeight: "bold",
                        }}
                      />
                    </div>
                    <div className="h-12 w-12 flex items-center justify-center rounded-full ">
                      <UserOutlined style={{ fontSize: "24px" }} />
                    </div>
                  </div>
                </Card>

                <Card
                  className="transition-all duration-300"
                  bodyStyle={{ padding: "20px" }}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-gray-600 text-sm font-medium mb-2">
                        Total Active Staff
                      </div>
                      <Statistic
                        value={count.active}
                        valueStyle={{
                          fontSize: "28px",
                          fontWeight: "bold",
                        }}
                      />
                    </div>
                    <div className="h-12 w-12 flex items-center justify-center rounded-full bg-green-100">
                      <UserAddOutlined
                        style={{ fontSize: "24px", color: "#52c41a" }}
                      />
                    </div>
                  </div>
                </Card>

                <Card
                  className="transition-all duration-300"
                  bodyStyle={{ padding: "20px" }}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="text-gray-600 text-sm font-medium mb-2">
                        Total Suspended Staff
                      </div>
                      <Statistic
                        value={count.inactive}
                        valueStyle={{
                          color: "#ff4d4f",
                          fontSize: "28px",
                          fontWeight: "bold",
                        }}
                      />
                    </div>
                    <div className="h-12 w-12 flex items-center justify-center rounded-full bg-red-100">
                      <UserDeleteOutlined
                        style={{ fontSize: "24px", color: "#ff4d4f" }}
                      />
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
          <div className="mt-4 ">
            <div className="flex items-center justify-end mb-2">
              <div className="w-[200px]">
                <Input
                  size=""
                  onChange={(e) => setinputname(e.target.value)}
                  className="placeholder:font-light"
                  placeholder="Search for a staff..."
                />
              </div>
              <div className=" ml-3">
                <ExcelExport
                  excelData={filteredData}
                  title={"Export Staff"}
                  fileName={`${companyname.replaceAll(" ", "_")}_staff_list`}
                />
              </div>
            </div>
            {loading ? (
              <TableSkimmer entries={12} />
            ) : (
              <>
                <div className="hidden items-center pt-4 justify-end">
                  <Select
                    style={{
                      width: 150,
                    }}
                    defaultValue={"all"}
                    className="w-[150px]"
                    onChange={(e) => {
                      if (e == "all") {
                        setfilter("all");
                      } else if (e == "active") {
                        setfilter("active");
                      } else if (e == "inactive") {
                        setfilter("inactive");
                      }
                    }}
                    options={[
                      { value: "all", label: "All users" },
                      { value: "active", label: "Active users" },
                      { value: "inactive", label: "Inactive users" },
                    ]}
                  />
                </div>

                <UserTable
                  columns={columns}
                  data={filteredData}
                  refreshBtn={setRefresh}
                />
              </>
            )}
          </div>
        </div>
      </div>
      <div className="h-[100px]"></div>
    </Layout>
  );
};

export default Users;
